module.exports = __webpack_public_path__ + "img/study_summary.e0292430.svg";